<template>
  <vx-card>
    <h4 class="mb-5">1. Induction</h4>
    <p class="mb-5 text-italic">
      *Please read this carefully as it is important. Remember this isn’t real - it’s virtual! This
      induction simply acts as a guide for what you might expect in a real life work experience
      setting.
    </p>
    <p class="mb-5">
      Welcome to your acting work experience induction! Through this work experience, you will gain
      valuable insights into the exciting world of the arts and entertainment industry.
    </p>
    <p class="mb-5">
      A big part of work experience is coming in with a great attitude and lots of enthusiasm as
      well as a place for you to learn lots of new things.
    </p>
    <p class="mb-5">
      Being an actor is a fun, interesting and varied career path. But before we jump in with the
      fun stuff, below are some of the things that will be expected of you and what will be covered
      during your work experience.
    </p>

    <div class="vx-row mt-10 mb-5">
      <div class="vx-col xl:w-2/3 w-full my-5">
        <responsive-iframe-youtube :src="video.url" :posterimg="video.image" />
      </div>
    </div>

    <h4 class="mb-5">Resources</h4>

    <vs-list>
      <vs-list-item
        title="Induction Sheet"
        subtitle="An overview of what is expected of you and the rules you must follow."
      >
        <vs-button
          color="success"
          type="gradient"
          href="https://www.careertools.com.au/vje/content/nurse/induction_sheet_nursing.pdf"
          target="_blank"
          >Download</vs-button
        >
      </vs-list-item>
    </vs-list>
  </vx-card>
</template>

<script>
import store from '@/store/store';

export default {
  computed: {
    activeExperienceID() {
      return store.getters['authStudent/activeExperienceID'];
    },
    experience() {
      const loginType = localStorage.getItem('login_type');
      if (loginType == 'student') {
        const experiences = store.getters['authStudent/experiences'];
        return experiences.find((i) => i.id == this.activeExperienceID);
      } else {
        return store.getters['authTeacher/experience'];
      }
    },
    video() {
      return {
        //url: 'https://www.careertools.com.au/vje/content/' + this.experience.vje.folder_name.toLowerCase() + '/virtual_tour.mp4',
        url: 'https://www.youtube.com/embed/EM1iP3iHhKE',
        image: require('@/assets/images/experiences/' +
          this.experience.vje.folder_name.toLowerCase() +
          '/virtual_tour.jpg'),
      };
    },
  },
};
</script>
